import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield, Mail, Phone, Clock, ExternalLink } from 'lucide-react';
import { GrasrotandelenBanner } from '../components/GrasrotandelenBanner';

import i18n from '../i18n';
import { useTranslation } from 'react-i18next';
const t = (k, o) => i18n.t(k, o);

export const Personvern = () => {
  useTranslation();
  return (
    <div data-testid="personvern-page" className="min-h-screen bg-slate-50 dark:bg-slate-900">
      {/* Hero Section */}
      <section className="relative py-20 px-4 sm:px-6 lg:px-8 bg-white border-b border-slate-200 dark:border-slate-700">
        <div className="max-w-4xl mx-auto">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-slate-500 hover:text-green-600 transition-colors mb-8"
          >
            <ArrowLeft className="w-4 h-4" />
            {t('pg.Personvern.8560fc')}
          </Link>
          
          <div className="flex items-center gap-4 mb-6">
            <div className="w-14 h-14 bg-green-100 rounded-xl flex items-center justify-center">
              <Shield className="w-7 h-7 text-green-600" />
            </div>
            <div>
              <p className="text-green-600 font-medium uppercase tracking-widest mb-1">{t('pg.Personvern.e9727d')}</p>
              <h1 className="text-4xl sm:text-5xl font-bold tracking-tighter text-slate-900 dark:text-white">
                {t('pg.Personvern.c22722')}
              </h1>
            </div>
          </div>
          
          <p className="text-slate-600 text-lg">
            {t('pg.Personvern.171011')}
          </p>
          <p className="text-slate-500 text-sm mt-4">
            {t('pg.Personvern.4561b0')}
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Introduction */}
          <div className="bg-white rounded-2xl border border-slate-200 p-6 sm:p-8 mb-8 shadow-sm">
            <p className="text-slate-600 leading-relaxed">
              {t('pg.Personvern.b918d5')}
            </p>
          </div>

          {/* Section 1 */}
          <div className="bg-white rounded-2xl border border-slate-200 p-6 sm:p-8 mb-6 shadow-sm">
            <h2 className="text-xl font-bold text-slate-900 mb-4 flex items-center gap-2">
              <span className="w-8 h-8 bg-green-500 text-white rounded-lg flex items-center justify-center text-sm font-bold">1</span>
              {t('pg.Personvern.0beb9d')}
            </h2>
            <p className="text-slate-600 mb-6">{t('pg.Personvern.3efd39')}</p>
            
            <div className="space-y-4">
              <div className="bg-slate-50 rounded-xl p-4 border border-slate-100">
                <h3 className="font-semibold text-slate-900 mb-2">{t('pg.Personvern.eba835')}</h3>
                <p className="text-slate-600 text-sm">
                  {t('pg.Personvern.ace661')}
                </p>
              </div>
              
              <div className="bg-slate-50 rounded-xl p-4 border border-slate-100">
                <h3 className="font-semibold text-slate-900 mb-2">{t('pg.Personvern.5de845')}</h3>
                <p className="text-slate-600 text-sm">
                  {t('pg.Personvern.0ef7f0')}
                </p>
              </div>
              
              <div className="bg-slate-50 rounded-xl p-4 border border-slate-100">
                <h3 className="font-semibold text-slate-900 mb-2">{t('pg.Personvern.17ffc9')}</h3>
                <p className="text-slate-600 text-sm">
                  {t('pg.Personvern.45f101')}
                </p>
              </div>
              
              <div className="bg-slate-50 rounded-xl p-4 border border-slate-100">
                <h3 className="font-semibold text-slate-900 mb-2">{t('pg.Personvern.6ef4ca')}</h3>
                <p className="text-slate-600 text-sm">
                  {t('pg.Personvern.1ffee7')}
                </p>
              </div>
              
              <div className="bg-slate-50 rounded-xl p-4 border border-slate-100">
                <h3 className="font-semibold text-slate-900 mb-2">{t('pg.Personvern.5fb715')}</h3>
                <p className="text-slate-600 text-sm">
                  {t('pg.Personvern.5ddc6a')}
                </p>
              </div>
              
              <div className="bg-slate-50 rounded-xl p-4 border border-slate-100">
                <h3 className="font-semibold text-slate-900 mb-2">{t('pg.Personvern.77c654')}</h3>
                <p className="text-slate-600 text-sm">
                  {t('pg.Personvern.237bb7')}
                </p>
              </div>
            </div>
          </div>

          {/* Section 2 */}
          <div className="bg-white rounded-2xl border border-slate-200 p-6 sm:p-8 mb-6 shadow-sm">
            <h2 className="text-xl font-bold text-slate-900 mb-4 flex items-center gap-2">
              <span className="w-8 h-8 bg-green-500 text-white rounded-lg flex items-center justify-center text-sm font-bold">2</span>
              {t('pg.Personvern.347a39')}
            </h2>
            <p className="text-slate-600 mb-6">{t('pg.Personvern.063158')}</p>
            
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-slate-200 dark:border-slate-700">
                    <th className="text-left py-3 px-4 font-semibold text-slate-900 dark:text-white">{t('pg.Personvern.55d155')}</th>
                    <th className="text-left py-3 px-4 font-semibold text-slate-900 dark:text-white">{t('pg.Personvern.cf4310')}</th>
                    <th className="text-left py-3 px-4 font-semibold text-slate-900 dark:text-white">{t('pg.Personvern.143ccc')}</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100">
                  <tr className="hover:bg-slate-50 dark:bg-slate-900">
                    <td className="py-3 px-4 text-slate-600 dark:text-slate-300">{t('pg.Personvern.706d8d')}</td>
                    <td className="py-3 px-4 text-slate-600 dark:text-slate-300">{t('pg.Personvern.1ddae9')}</td>
                    <td className="py-3 px-4 text-slate-600 dark:text-slate-300">{t('pg.Personvern.6907c9')}</td>
                  </tr>
                  <tr className="hover:bg-slate-50 dark:bg-slate-900">
                    <td className="py-3 px-4 text-slate-600 dark:text-slate-300">{t('pg.Personvern.7792be')}</td>
                    <td className="py-3 px-4 text-slate-600 dark:text-slate-300">{t('pg.Personvern.87a1da')}</td>
                    <td className="py-3 px-4 text-slate-600 dark:text-slate-300">{t('pg.Personvern.5f821f')}</td>
                  </tr>
                  <tr className="hover:bg-slate-50 dark:bg-slate-900">
                    <td className="py-3 px-4 text-slate-600 dark:text-slate-300">{t('pg.Personvern.6e84c7')}</td>
                    <td className="py-3 px-4 text-slate-600 dark:text-slate-300">{t('pg.Personvern.8399f7')}</td>
                    <td className="py-3 px-4 text-slate-600 dark:text-slate-300">{t('pg.Personvern.fa21b2')}</td>
                  </tr>
                  <tr className="hover:bg-slate-50 dark:bg-slate-900">
                    <td className="py-3 px-4 text-slate-600 dark:text-slate-300">{t('pg.Personvern.3e54e7')}</td>
                    <td className="py-3 px-4 text-slate-600 dark:text-slate-300">{t('pg.Personvern.1529d1')}</td>
                    <td className="py-3 px-4 text-slate-600 dark:text-slate-300">{t('pg.Personvern.632694')}</td>
                  </tr>
                  <tr className="hover:bg-slate-50 dark:bg-slate-900">
                    <td className="py-3 px-4 text-slate-600 dark:text-slate-300">{t('pg.Personvern.3b56f9')}</td>
                    <td className="py-3 px-4 text-slate-600 dark:text-slate-300">{t('pg.Personvern.d20674')}</td>
                    <td className="py-3 px-4 text-slate-600 dark:text-slate-300">{t('pg.Personvern.c0deb9')}</td>
                  </tr>
                  <tr className="hover:bg-slate-50 dark:bg-slate-900">
                    <td className="py-3 px-4 text-slate-600 dark:text-slate-300">{t('pg.Personvern.6fdc3f')}</td>
                    <td className="py-3 px-4 text-slate-600 dark:text-slate-300">{t('pg.Personvern.548207')}</td>
                    <td className="py-3 px-4 text-slate-600 dark:text-slate-300">{t('pg.Personvern.28fce5')}</td>
                  </tr>
                  <tr className="hover:bg-slate-50 dark:bg-slate-900">
                    <td className="py-3 px-4 text-slate-600 dark:text-slate-300">{t('pg.Personvern.29e7e9')}</td>
                    <td className="py-3 px-4 text-slate-600 dark:text-slate-300">{t('pg.Personvern.d20674')}</td>
                    <td className="py-3 px-4 text-slate-600 dark:text-slate-300">{t('pg.Personvern.5615a6')}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Section 3 */}
          <div className="bg-white rounded-2xl border border-slate-200 p-6 sm:p-8 mb-6 shadow-sm">
            <h2 className="text-xl font-bold text-slate-900 mb-4 flex items-center gap-2">
              <span className="w-8 h-8 bg-green-500 text-white rounded-lg flex items-center justify-center text-sm font-bold">3</span>
              {t('pg.Personvern.69a524')}
            </h2>
            <p className="text-slate-600 mb-4">
              {t('pg.Personvern.c5d5fd')}
            </p>
            
            <div className="space-y-3">
              <div className="flex items-start gap-3 bg-green-50 rounded-lg p-4 border border-green-100">
                <div className="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-slate-700 text-sm">
                  <strong>{t('pg.Personvern.7d0a0c')}</strong> {t('pg.Personvern.8556f0')}
                </p>
              </div>
              <div className="flex items-start gap-3 bg-amber-50 rounded-lg p-4 border border-amber-100">
                <div className="w-2 h-2 bg-amber-500 rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-slate-700 text-sm">
                  <strong>{t('pg.Personvern.62fa7e')}</strong> {t('pg.Personvern.f72446')}
                </p>
              </div>
              <div className="flex items-start gap-3 bg-blue-50 rounded-lg p-4 border border-blue-100">
                <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-slate-700 text-sm">
                  <strong>{t('pg.Personvern.1cb0db')}</strong> {t('pg.Personvern.18187e')}
                </p>
              </div>
            </div>
          </div>

          {/* Section 4 */}
          <div className="bg-white rounded-2xl border border-slate-200 p-6 sm:p-8 mb-6 shadow-sm">
            <h2 className="text-xl font-bold text-slate-900 mb-4 flex items-center gap-2">
              <span className="w-8 h-8 bg-green-500 text-white rounded-lg flex items-center justify-center text-sm font-bold">4</span>
              {t('pg.Personvern.fb105a')}
            </h2>
            <p className="text-slate-600 mb-4">{t('pg.Personvern.d21906')}</p>
            
            <ul className="space-y-2 mb-4">
              <li className="flex items-start gap-2 text-slate-600 text-sm">
                <span className="text-green-500 mt-1">•</span>
                {t('pg.Personvern.b92180')}
              </li>
              <li className="flex items-start gap-2 text-slate-600 text-sm">
                <span className="text-green-500 mt-1">•</span>
                {t('pg.Personvern.161dee')}
              </li>
              <li className="flex items-start gap-2 text-slate-600 text-sm">
                <span className="text-green-500 mt-1">•</span>
                {t('pg.Personvern.3faf4d')}
              </li>
              <li className="flex items-start gap-2 text-slate-600 text-sm">
                <span className="text-green-500 mt-1">•</span>
                {t('pg.Personvern.541d8f')}
              </li>
              <li className="flex items-start gap-2 text-slate-600 text-sm">
                <span className="text-green-500 mt-1">•</span>
                {t('pg.Personvern.2af700')}
              </li>
            </ul>
            
            <div className="bg-red-50 border border-red-200 rounded-lg p-4">
              <p className="text-red-800 font-semibold text-sm">
                {t('pg.Personvern.e04bfc')}
              </p>
            </div>
          </div>

          {/* Section 5 */}
          <div className="bg-white rounded-2xl border border-slate-200 p-6 sm:p-8 mb-6 shadow-sm">
            <h2 className="text-xl font-bold text-slate-900 mb-4 flex items-center gap-2">
              <span className="w-8 h-8 bg-green-500 text-white rounded-lg flex items-center justify-center text-sm font-bold">5</span>
              {t('pg.Personvern.bd35da')}
            </h2>
            
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-slate-600 dark:text-slate-300">
                <Clock className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" />
                <span className="text-sm">
                  <strong>{t('pg.Personvern.4474fb')}</strong> {t('pg.Personvern.2e7906')}
                </span>
              </li>
              <li className="flex items-start gap-3 text-slate-600 dark:text-slate-300">
                <Clock className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" />
                <span className="text-sm">
                  <strong>{t('pg.Personvern.6aa9d0')}</strong> {t('pg.Personvern.3f2ff3')}
                </span>
              </li>
              <li className="flex items-start gap-3 text-slate-600 dark:text-slate-300">
                <Clock className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" />
                <span className="text-sm">
                  <strong>{t('pg.Personvern.d17e08')}</strong> {t('pg.Personvern.714539')}
                </span>
              </li>
            </ul>
          </div>

          {/* Section 6 */}
          <div className="bg-white rounded-2xl border border-slate-200 p-6 sm:p-8 mb-6 shadow-sm">
            <h2 className="text-xl font-bold text-slate-900 mb-4 flex items-center gap-2">
              <span className="w-8 h-8 bg-green-500 text-white rounded-lg flex items-center justify-center text-sm font-bold">6</span>
              {t('pg.Personvern.13af47')}
            </h2>
            <p className="text-slate-600 mb-4">{t('pg.Personvern.e852b2')}</p>
            
            <div className="grid sm:grid-cols-2 gap-3">
              <div className="bg-slate-50 rounded-lg p-4 border border-slate-100">
                <p className="text-slate-700 text-sm">{t('pg.Personvern.4c3913')}</p>
              </div>
              <div className="bg-slate-50 rounded-lg p-4 border border-slate-100">
                <p className="text-slate-700 text-sm">{t('pg.Personvern.eaa7b4')}</p>
              </div>
              <div className="bg-slate-50 rounded-lg p-4 border border-slate-100">
                <p className="text-slate-700 text-sm">{t('pg.Personvern.f94cd6')}</p>
              </div>
              <div className="bg-slate-50 rounded-lg p-4 border border-slate-100">
                <p className="text-slate-700 text-sm">{t('pg.Personvern.16a59c')}</p>
              </div>
            </div>
          </div>

          {/* Section 7 */}
          <div className="bg-white rounded-2xl border border-slate-200 p-6 sm:p-8 mb-6 shadow-sm">
            <h2 className="text-xl font-bold text-slate-900 mb-4 flex items-center gap-2">
              <span className="w-8 h-8 bg-green-500 text-white rounded-lg flex items-center justify-center text-sm font-bold">7</span>
              {t('pg.Personvern.01eb98')}
            </h2>
            <p className="text-slate-600 mb-4">{t('pg.Personvern.6ae7ea')}</p>
            
            <div className="grid sm:grid-cols-2 gap-3">
              <div className="flex items-center gap-2 bg-green-50 rounded-lg p-3 border border-green-100">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span className="text-slate-700 text-sm">{t('pg.Personvern.2663d2')}</span>
              </div>
              <div className="flex items-center gap-2 bg-green-50 rounded-lg p-3 border border-green-100">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span className="text-slate-700 text-sm">{t('pg.Personvern.7645d2')}</span>
              </div>
              <div className="flex items-center gap-2 bg-green-50 rounded-lg p-3 border border-green-100">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span className="text-slate-700 text-sm">{t('pg.Personvern.1dbb1e')}</span>
              </div>
              <div className="flex items-center gap-2 bg-green-50 rounded-lg p-3 border border-green-100">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span className="text-slate-700 text-sm">{t('pg.Personvern.30015d')}</span>
              </div>
              <div className="flex items-center gap-2 bg-green-50 rounded-lg p-3 border border-green-100">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span className="text-slate-700 text-sm">{t('pg.Personvern.0fc1b5')}</span>
              </div>
              <div className="flex items-center gap-2 bg-green-50 rounded-lg p-3 border border-green-100">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span className="text-slate-700 text-sm">{t('pg.Personvern.71e1fd')}</span>
              </div>
            </div>
            
            <div className="mt-4 bg-slate-50 rounded-lg p-4 border border-slate-200 dark:border-slate-700">
              <p className="text-slate-600 text-sm">
                {t('pg.Personvern.4f69ea')}{' '}
                <a 
                  href="https://www.datatilsynet.no/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-green-600 hover:underline inline-flex items-center gap-1"
                >
                  {t('pg.Personvern.7449f4')}
                  <ExternalLink className="w-3 h-3" />
                </a>
                {' '}{t('pg.Personvern.32b1fa')}
              </p>
            </div>
          </div>

          {/* Section 8 - Contact */}
          <div className="bg-gradient-to-br from-green-500 to-green-600 rounded-2xl p-6 sm:p-8 text-white shadow-lg">
            <h2 className="text-xl font-bold mb-4 flex items-center gap-2">
              <span className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center text-sm font-bold">8</span>
              {t('pg.Personvern.8d1c6b')}
            </h2>
            <p className="text-green-50 mb-6">
              {t('pg.Personvern.1467d4')}
            </p>
            
            <div className="bg-white/10 backdrop-blur rounded-xl p-5 mb-6">
              <p className="font-semibold text-lg mb-1">{t('pg.Personvern.dc68ad')}</p>
              <p className="text-green-100 mb-4">{t('pg.Personvern.1661c3')}</p>
              
              <div className="space-y-2">
                <a 
                  href="mailto:nickolas.paynter@veitvet-sportsklubb.no?subject=Personvernhenvendelse"
                  className="flex items-center gap-2 text-white hover:text-green-200 transition-colors"
                >
                  <Mail className="w-4 h-4" />
                  nickolas.paynter@veitvet-sportsklubb.no
                </a>
                <a 
                  href="tel:+4790739749"
                  className="flex items-center gap-2 text-white hover:text-green-200 transition-colors"
                >
                  <Phone className="w-4 h-4" />
                  +47 907 39 749
                </a>
                <p className="flex items-center gap-2 text-green-200 text-sm">
                  <Clock className="w-4 h-4" />
                  {t('pg.Personvern.093ade')}
                </p>
              </div>
            </div>
            
            <div className="bg-white/10 backdrop-blur rounded-xl p-4">
              <p className="text-green-50 text-sm">
                <strong>{t('pg.Personvern.22d5c5')}</strong><br />
                {t('pg.Personvern.b3a8a4')}
              </p>
            </div>
          </div>

          {/* Closing */}
          <div className="text-center mt-12 mb-8">
            <p className="text-slate-600 mb-2">{t('pg.Personvern.cf2f54')}</p>
            <p className="text-slate-500 text-sm">{t('pg.Personvern.4a5906')}<br />{t('pg.Personvern.be7fe9')}</p>
          </div>
        </div>
      </section>

      {/* Grasrotandelen Banner */}
      <GrasrotandelenBanner />
    </div>
  );
};

export default Personvern;
